import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Icon } from '../components/Icon';

/** @typedef { import('models/user/_types').User } User */
/** @typedef { import('@mui/material/Box').BoxProps } BoxProps */

/**
 * @typedef { object } CustomErrorObject
 * @prop { string } [message]
 */

/** @type { (unknownError: string | Error | CustomErrorObject) => string } */
const getErrorMessage = (unknownError) => {
  if (typeof unknownError === 'string') {
    return unknownError;
  }
  if (
    unknownError &&
    Object.prototype.hasOwnProperty.call(unknownError, 'message') &&
    typeof unknownError.message === 'string'
  ) {
    return unknownError.message;
  }
  return 'Unknown error';
};

/**
 * @typedef { object } Props
 * @prop { BoxProps['sx'] } [sx]
 * @prop { boolean } [compact]
 * @prop { string | Error | CustomErrorObject } errorMessage
 * @prop { string } title
 */

/** @type { React.FC<Props> } */
export const ErrorDisplay = ({ title, errorMessage, sx, compact = false }) => {
  return (
    (<Box sx={{ py: 3, px: 3, textAlign: 'center', ...sx }}>
      {!compact && (
        <Icon
          color="error"
          icon={icon({ name: 'exclamation-triangle', style: 'regular' })}
          size="large"
          sx={{ mb: 3 }}
        />
      )}
      <Typography color="error" variant="h6" sx={{ mb: 3 }} gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" sx={{
        color: "text.secondary"
      }}>
        {getErrorMessage(errorMessage)}
      </Typography>
    </Box>)
  );
};
